<template>
  <div class="flex flex-col px-3 laptop:w-3/4 laptop:mx-auto bg-white min-h-screen font-quicksand">
          <div class="w-64 self-center laptop:self-start mt-12 laptop:mt-2">
            <img class="" src="@/assets/images/nomado.png" />
          </div>
            <loginForm :doAuth="Authenticate" v-if="showLogin" />
            <smsForm v-if="showSMS" />
          <Footer class="mb-2" />
    <notifications group="nomado"
    position="bottom left"
    />
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import loginForm from "@/components/loginForm.vue";
import smsForm from '@/components/sendSMS.vue';
import Footer from '@/components/footer.vue';
import axios from 'axios';

export default {
    name: "App",
    data() {
        return {
            currentComponent: 'loginForm',
            username:'',
            password: '',
            ls: window.localStorage
        }
    },
    methods: {
        async Authenticate(username, password) {
            this.$Progress.start()
            const credentials = this.toBase64(`${username}:${password}`)

            const result= await axios.post('https://api.nomado.eu/core/auth/login',{},{
                headers: {
                    'Authorization': `Basic ${credentials}`
                }
            })

            if (!result.data.login_success) {
                this.$Progress.fail()
                this.$notify({
                    group: 'nomado',
                    type: 'error',
                    title: 'Authentication failed',
                    text: 'Username or password invalid. Please try again!'
                })
                return false
            }

            this.saveCredentials(username, password)
            this.currentComponent = 'smsForm'
            this.$Progress.finish()
        },

        toBase64(str) {

            return Buffer.from(str).toString('base64');
        },

        saveCredentials(username, password) {
            
            //save in localStorage
            this.ls.setItem('username', username)
            this.ls.setItem('password', password)
            this.ls.setItem('credentials', this.toBase64(`${username}:${password}`))
        }
    },
    computed: {
        showLogin() {
            return (this.currentComponent === 'loginForm') ? true : false
        },
        showSMS() { 
            return (this.currentComponent === 'smsForm') ? true : false
        }
    },
    mounted() {
        if (this.ls.getItem('username') && this.ls.getItem('password')) {
            
            this.Authenticate(this.ls.getItem('username'), this.ls.getItem('password'))
                .then(result => {
                    if (result) this.currentComponent = 'smsForm'
                })
        }
    },
    created() {
        // setting progressbar
        this.$Progress.setColor('#008ad7')
    },
    components: {
        loginForm,
        smsForm,
        Footer
    }
};
</script>

<style lang="scss"></style>
